import WizardInfo from '../wizard-info/wizard-info';
import './logo.scss';
import YouTrackLogo from '@jetbrains/logos/youtrack/youtrack.svg';
import UpsourceLogo from '@jetbrains/logos/upsource/upsource.svg';
import TeamCityLogo from '@jetbrains/logos/teamcity/teamcity.svg';
import HubLogo from '@jetbrains/logos/hub/hub.svg';

const serviceIcons = {
  youtrack: YouTrackLogo,
  upsource: UpsourceLogo,
  teamcity: TeamCityLogo,
  hub: HubLogo
};

export default angular.module('installer.logo', [WizardInfo.name]).
  directive('logo', wizardInfo => ({
    restrict: 'E',
    template: require('./logo.html'),
    scope: true,
    link: scope => {
      scope.productName = wizardInfo.productName;

      scope.getServiceLogo = serviceName => serviceIcons[serviceName.toLowerCase()];
    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/logo/logo.js